module.exports = __webpack_public_path__ + "static/color-multi.2cdcf754.png";